/*
*###############################################################################
*Module Name                   : DPSearchBoxDynamicHeadOffice.js                      #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*
* NOTE: This component implements debounced search functionality using lodash.debounce
* to improve performance by preventing excessive API calls while typing.
* The search is triggered 1000ms after the user stops typing.
*/
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal, Spinner, Input, InputGroup, InputGroupText, FormGroup, Label } from "reactstrap"
import "../../assets/scss/datatables.scss"
import ReactPaginate from 'react-paginate';
import "../../assets/scss/searchtable.scss"
import { debounce } from 'lodash';
import { loadPopupSearchPayHeadOffice } from "framework/validators/SearchColumn";


const DPSearchBoxDynamicHeadOffice = (props) => {

    const [searchPlaceholder, setSearchPlaceholder] = useState(`Search By ${props.columns.length > 0 ? props.columns[0].title : 'Code'}`)
    const [searchBy, setSearchBy] = useState(props.searchBy) //filter code ex: CM_CODE
    const [columns, setColumns] = useState([]) //columns for table
    const [page, setPage] = useState(0) //current page
    const [pageSize, setPageSize] = useState(10) //page size
    const [count, setCount] = useState(0) //total row count
    const [data, setData] = useState([]) //data for table
    const [isLoaded, setIsLoaded] = useState(false)
    const [searchString, setSearchString] = useState("0") //user entered search string
    const [isDataLoaded, setIsDataLoaded] = useState(false)
    const tableRef = useRef(null);    const [orderBy, setOrderBy] = useState("ASC")//order by ASC or DESC
    const [OrderByString, setOrderByString] = useState(props.columns.length > 0 ? props.columns[0].title : 'Code')
    const [selectedRow, setSelectedRow] = useState(0); //highlight selected row , selected row index
    const [selectedColumn, setSelectedColumn] = useState(0); //selected column for search
    const searchref = useRef(null); //search input ref
    const [searchPlace, setSearchPlace] = useState(0)
    const [isDebouncing, setIsDebouncing] = useState(false) // New state to track debounced search status

    useEffect(async () => { //when model toggle set default values
        setSearchBy(props.searchBy)
        setSearchPlaceholder(`Search By ${props.columns.length > 0 ? props.columns[0].title : 'Code'}`)
        setPage(0)
        setPageSize(10)
        setSelectedColumn(0)
        setCount(0)
        setOrderBy(props.orderBy ? props.orderBy : "ASC")

        if (props.isOpen == true) {
            // setData([])
            setIsLoaded(true)
            setColumns(await loadPopupSearchPayHeadOffice(props.MenuCode, props.URLPath)) //get table columns from server 
            await getData(); //get row data from server        } else {
            setIsLoaded(false)
            setData([])
            setSelectedRow(0)
        }
        setSearchString("0")
        setIsDebouncing(false) // Reset debouncing state when modal toggle

    }, [props.isOpen])


    useEffect(async () => {
        if (isLoaded) {
            setOrderBy(props.orderBy ? props.orderBy : "ASC")
            // setColumns(await loadPopupSearchPayHeadOffice(props.MenuCode, props.URLPath)) //get table columns from server 
            // await getData(); //get row data from server
        }
    }, [isLoaded])

    useEffect(async () => {
        await getData();
    }, [page, pageSize, searchString, orderBy, searchBy]) // when page, page size, search string, order by, search by change get data from server


    async function getData() {
        if (props.MenuCode == undefined || props.MenuCode == null || props.MenuCode == "" || props.isOpen == false) return // if menu code is not set return from function
        const authToken = localStorage.getItem("authToken")
        setIsDataLoaded(true)

        var FilterString = props.FilterStr;

        await fetch(`${props.APIURL}common/headOffice`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify({
                strMenuCode: props.MenuCode,
                strSearchControl: props.URLPath,
                strSearchKey: props.KeyVal,
                strSearchCol: searchBy,
                strSearchVal: searchString === "" ? "0" : searchString,
                intPageNo: page,
                intRowPerPage: pageSize,
                strFilter: FilterString,
                orderBy: orderBy,
                searchPlace: searchPlace
            })
        }).then(async (Response) => await Response.json())
            .then(async (responseData) => {
                if (responseData.success == true) {
                    var tabledata = responseData.data
                    var pagecount = responseData.count

                    setCount(pagecount)
                    setData(tabledata)

                } else {
                    setCount(0)
                    setData([])
                }
                setIsDataLoaded(false)
            }).catch((error) => {
                console.log(error)
                setIsDataLoaded(false)
                setCount(0)
                setData([])
            })
    }

    const handlePageClick = (event) => {
        setPage(event.selected);
    };

    if (searchref.current) {
        searchref.current.focus()
    }

    const handleKeyPress = (event) => { // key press event handling function 
        if (event.key === 'ArrowUp') { // if key is arrow up select previous row
            event.preventDefault();
            setSelectedRow((selectedRow) => Math.max(selectedRow - 1, 0));
        } else if (event.key === 'ArrowDown') { // if key is arrow down select next row
            event.preventDefault();
            setSelectedRow((selectedRow) => Math.min(selectedRow + 1, data.length - 1));
        } else if (event.key === 'Enter') { // if key is enter call select function
            if (data.length == 0) return
            props.getSelect(event, data[selectedRow])
        } else if (event.key === 'ArrowRight') { // if key is arrow right select next page
            setPage(e => {
                if (e + 1 <= count / pageSize) {
                    return e + 1
                } else {
                    return e
                }
            })
            setSelectedRow(0) // set selected row to 0 when page no cahge
        } else if (event.key === 'ArrowLeft') { // if key is arrow left select previous page
            setPage(e => {
                if (e - 1 >= 0) {
                    return e - 1
                } else {
                    return e
                }
            })
            setSelectedRow(0) // set selected row to 0 when page no cahge
        }

        if (event.ctrlKey && event.key == 'x') {
            // add your code to handle the Control + X key event here
            setSearchPlace(searchPlace == 0 ? 1 : 0)
        }
    };
    const handleOptionChange = (event) => {
        setSearchPlace(event.target.value);
    };

    const debouncedSearch = useCallback(
        debounce((value) => {
            setSearchString(value);
            setPage(0);
            setIsDebouncing(false); // Search is complete, turn off debouncing indicator
        }, 1000),
        []
    );

    const handleSearch = useCallback((e) => {
        const userInput = e.target.value;
        const sanitizedInput = userInput.replace(/[^a-zA-Z0-9 ]/g, '');
        setIsDebouncing(true); // Show that search is in debounce mode
        debouncedSearch(sanitizedInput);
    }, [debouncedSearch]);

    return (
        <div onKeyDown={handleKeyPress}
        >
            <Modal
                id="dynamicSearchModal"
                size="xl"
                isOpen={props.isOpen}
                toggle={props.toggle}
                centered
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">{props.SubTitle} </CardTitle>
                                    <p className="card-title-desc">
                                        {"Please click on the column header to change searching criteria. Press Ctrl + X to change search by first letter or middle letter."}
                                    </p>
                                    <>
                                        <div className="row mb-3 justify-content-end">                                            <div className="col-9">
                                                <div className="d-flex">
                                                    <FormGroup check inline>
                                                        <Input
                                                            type="radio"
                                                            id="searchMiddle"
                                                            name="searchType"
                                                            value="0"
                                                            checked={searchPlace == 0}
                                                            onChange={handleOptionChange}
                                                        />
                                                        <Label check for="searchMiddle">
                                                            Search by Middle Letter
                                                        </Label>
                                                    </FormGroup>
                                                    <FormGroup check inline>
                                                        <Input
                                                            type="radio"
                                                            id="searchFirst"
                                                            name="searchType"
                                                            value="1"
                                                            checked={searchPlace == 1}
                                                            onChange={handleOptionChange}
                                                        />
                                                        <Label check for="searchFirst">
                                                            Search by First Letter
                                                        </Label>
                                                    </FormGroup>
                                                </div>
                                            </div>                                            <div className="col-3">
                                                <InputGroup size="sm">
                                                    <InputGroupText>
                                                        {isDebouncing ? (
                                                            <i className="fas fa-spinner fa-spin text-primary" title="Search in progress..."></i>
                                                        ) : (
                                                            <i className="fas fa-search"></i>
                                                        )}
                                                    </InputGroupText>
                                                    <Input
                                                        innerRef={searchref}
                                                        id="SearchBarDynamic"
                                                        type="text"
                                                        placeholder={isDebouncing ? "Search in progress..." : searchPlaceholder}
                                                        onChange={handleSearch}
                                                    />
                                                </InputGroup>
                                                <div className="mt-1">
                                                    <small className="text-muted">
                                                        <i className="fas fa-info-circle me-1"></i>
                                                        Search starts automatically after you stop typing
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    <>
                                        <div class="table-container">
                                            <table className="custom-table table-bordered table-sm rounded" ref={tableRef} id="searchTable">
                                                <thead style={{ height: "35px", alignItems: "center", verticalAlign: "middle" }}>
                                                    {columns.map((column, index) => {
                                                        return (
                                                            <th key={index} style={{ textAlign: column.align, cursor: "pointer", background: "gainsboro" }} onClick={e => {                                                                setPage(0)
                                                                setSearchBy(column.field)
                                                                setSearchPlaceholder(`Search By ${column.title}`)
                                                                setOrderByString(column.title)
                                                                setIsDebouncing(false) // Reset debouncing state
                                                                setSearchString("0")

                                                                const element = document.getElementById("SearchBarDynamic");

                                                                if (element) {
                                                                    element.focus();
                                                                }

                                                                setSelectedColumn(pre => {
                                                                    if (pre == index) {
                                                                        orderBy == "ASC" ? setOrderBy("DESC") : setOrderBy("ASC")
                                                                    } else {
                                                                        setOrderBy("ASC")
                                                                    }
                                                                    return index
                                                                })
                                                            }}>{column.title}  {selectedColumn == index ? orderBy == "ASC" ? " ▲" : " ▼" : ""}</th>
                                                        )
                                                    })}
                                                </thead>
                                                <tbody>
                                                    {data.length > 0 ? data.map((row, index) => {
                                                        return (
                                                            <tr
                                                                key={index}
                                                                style={{ textAlign: "center" }}
                                                                className={index === selectedRow ? 'selectedrowsearch' : 'unselectedrowsearch'}
                                                                tabIndex={index === selectedRow ? 0 : -1}
                                                                onClick={e => {
                                                                    props.getSelect(e, row)
                                                                }}>
                                                                {columns.map((column, index) => {
                                                                    return (
                                                                        <td key={index} style={{ textAlign: column.align }}>{row[column.field]}</td>
                                                                    )
                                                                })}
                                                            </tr>
                                                        )
                                                    }) : (
                                                        <tr>
                                                            <td colSpan={props.columns.length} className="text-center">
                                                                <div className="text-muted">
                                                                    <i className="fas fa-search me-2"></i>
                                                                    No data found
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                        <div className="d-flex align-items-center">
                                            <span className="me-2">Page Size:</span>
                                            <Input
                                                type="select"
                                                bsSize="sm"
                                                style={{ width: "80px" }}
                                                value={pageSize}
                                                onChange={e => setPageSize(Number(e.target.value))}
                                            >
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </Input>
                                            <span className="ms-4">
                                                Total Records: {Math.ceil(count)}
                                            </span>
                                        </div>                                        <ReactPaginate
                                            previousLabel={<i className="fas fa-chevron-left" />}
                                            nextLabel={<i className="fas fa-chevron-right" />}
                                            breakLabel="..."
                                            pageCount={Math.ceil(count / pageSize)}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            forcePage={page}
                                            containerClassName="pagination pagination-sm mb-0"
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            activeClassName="active"
                                        />
                                    </div>
                                
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </div>
            </Modal>

        </div>
    );
}

export default DPSearchBoxDynamicHeadOffice;




